import request from '@/utils/request';

/**
 * 按类型查询私有库列表
 * @param {number} type 1=桥段配置 2=写作风格 3=特色词汇 4=热梗奇思
 */
export function listPrivateLib(type) {
  return request({
    url: '/front/privateLib/list',
    method: 'get',
    params: { type }
  });
}

export function getPrivateLib(id) {
  return request({
    url: `/front/privateLib/${id}`,
    method: 'get'
  });
}

export function createPrivateLib(data) {
  return request({
    url: '/front/privateLib',
    method: 'post',
    data
  });
}

export function updatePrivateLib(id, data) {
  return request({
    url: `/front/privateLib/${id}`,
    method: 'put',
    data
  });
}

export function deletePrivateLib(id) {
  return request({
    url: `/front/privateLib/${id}`,
    method: 'delete'
  });
}
